import script from "./ProjectManageUploadSettingPresetSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectManageUploadSettingPresetSection.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectManageUploadSettingPresetSection.vue?vue&type=style&index=0&id=e3fc8760&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3fc8760"]])

export default __exports__